// components/Auth/ProtectedRoute.tsx (enhanced)
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useUserGroups } from '../../hooks/useUserGroups';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredGroup?: string; // Optional group requirement
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredGroup 
}) => {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, userGroups, loading: groupsLoading } = useUserGroups();
  const location = useLocation();

  if (authLoading || groupsLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/dashboard/login" state={{ from: location }} replace />;
  }

  // Check if user has required group permissions
  if (requiredGroup) {
    const hasPermission = requiredGroup === 'Admin' ? isAdmin : userGroups.includes(requiredGroup);
    if (!hasPermission) {
      return (
        <div style={{ padding: '20px' }}>
          <h2>Access Denied</h2>
          <p>You do not have permission to access this page.</p>
        </div>
      );
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;